const $ = jQuery

const slideNext = () => {
  const active = $('.gallerylinks > a.active');
  const  length = $('.gallerylinks').length;
  
  if( active.attr('href') == $('.gallerylinks > a').last().attr('href') ) {
    $('.gallerylinks > a').eq(0).addClass('active');
  } else {
    active.next().addClass('active');
  }
  
  active.removeClass('active');
}

const slidePrev = () => {
  var active = $('.gallerylinks > a.active');
  var length = $('.gallerylinks').length;
  
  if( active.attr('href') == $('.gallerylinks > a').first().attr('href') ) {
    $('.gallerylinks > a').last().addClass('active');
  } else {
    active.prev().addClass('active');
  }
  
  active.removeClass('active');
}

const slideStarting = () => {
  $('.slideshow > .slides').cycle({
    timeout: 0,
    speed: 0,
    next: '#next',
    prev: '#prev',
    pager: '#nav',
    pagerAnchorBuilder: function(idx, slide) {
      return '<li><a href="#"><img src="'+slide.src+'" /></a></li>';
    }
  });
}

( () => {
  const slides = $('.slideshow')

  $('.slideshow #next').on('click', slideNext)
  $('.slideshow #prev').on('click', slidePrev)
  
  if( slides.length ){
    slideStarting()

    $('.slideshow .gallery-img').colorbox({
      rel: 'gallery-img',
      maxWidth: '60%',
      maxHeight: '80%',
      transition: 'none'
    });
  }
})()